import { ZillowResearchLayout } from '@zillow/zrs-cms';
import React from 'react';

import ContentTemplate from '../../components/ContentTemplate';
import LayoutWrapper from '../../components/LayoutWrapper';
import {
    buildPrimaryPostPage,
    LayoutComponentProps,
} from '../../util/buildPrimaryPostPage';

export const ResearchLayout: React.FC<LayoutComponentProps> = (props) => {
    return (
        <LayoutWrapper
            {...props}
            LayoutComponent={ZillowResearchLayout}
            defaultTitle="Zillow Research"
        />
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'RESEARCH',
        basePath: '/research',
        ContentComponent: ContentTemplate,
        LayoutComponent: ResearchLayout,
        contentType: 'B2C',
        menuPropName: 'submenu',
        hasStickyNav: true,
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
